import React from "react";
import { IS_VALID } from "utils";

let schema = {
  className: "VoucherUpdateLogs",
  limit: 10,
  showExport: false,
  showCreate: false,
  showUpdate: false,
  showDelete: false,
  bypassAccess: true,
  columns: [
    {
      columnName: "objectId",
  		type: "string"
    },
    // {
    //   columnName: "daily_voucher_log",
    //   columnLabel: "daily voucher log",
  	// 	type: "string",
    //   render: ({ value }) => {
    //     let renderValue = "";

    //     if (IS_VALID(value)) {
    //       renderValue = (
    //         <p style={{ overflow: "scroll", whiteSpace: "pre" }}>
    //           {value}
    //         </p>
    //       );
    //     }

    //     return renderValue;
    //   }
    // },
    // {
    //   columnName: "campaign_period_voucher_log",
    //   columnLabel: "campaign period voucher log",
  	// 	type: "string",
    //   render: ({ value }) => {
    //     let renderValue = "";

    //     if (IS_VALID(value)) {
    //       renderValue = (
    //         <p style={{ overflow: "scroll", whiteSpace: "pre" }}>
    //           {value}
    //         </p>
    //       );
    //     }

    //     return renderValue;
    //   }
    // },
    // {
    //   columnName: "date_range_voucher_log",
    //   columnLabel: "date range voucher log",
  	// 	type: "string",
    //   render: ({ value }) => {
    //     let renderValue = "";

    //     if (IS_VALID(value)) {
    //       renderValue = (
    //         <p style={{ overflow: "scroll", whiteSpace: "pre" }}>
    //           {value}
    //         </p>
    //       );
    //     }

    //     return renderValue;
    //   }
    // },
    {
      columnName: "status",
      type: "string"
    },
    {
      columnName: "startTime",
      columnLabel: "start",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A"
    },
    {
      columnName: "endTime",
      columnLabel: "end",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A"
    },
    {
      columnName: "duration",
      type: "number",
      render: ({ object }) => {
        let renderValue = "";

        if (IS_VALID(object.get("duration"))) {
          renderValue = `${parseFloat(object.get("duration")).toFixed(3)} minutes`;
        }
        return renderValue;
      }
    },
    // {
    //   columnName: "server_tdd_startDate",
    //   columnLabel: "server tdd start",
  	// 	type: "Date",
    //   format: "MM/DD/YYYY hh:mm:ss A"
    // },
    // {
    //   columnName: "server_tdd_endDate",
    //   columnLabel: "server tdd end",
  	// 	type: "Date",
    //   format: "MM/DD/YYYY hh:mm:ss A"
    // },
    {
      columnName: "createdAt",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A"
    },
    {
      columnName: "updatedAt",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A"
    }
  ]
}

module.exports = schema;



// WEBPACK FOOTER //
// ./components/EVoucherUpdateLogs/VoucherUpdateLogs.js